import { defineMessages } from "react-intl";

export const messages = defineMessages({
    migrationStatusTableHeading: {
        id: "fastshift.dashboard.migrationStatusTable.heading",
        defaultMessage: "Migration progress",
        description: "Heading of the migration status table"
    },
    errorMessageDescription: {
        id: "fastshift.dashboard.migrationStatusTable.error-message-description",
        defaultMessage:
            "We’re unable to retrieve the data about your migration progress.",
        description: "Error message for migration status table"
    }
});
